// extracted by mini-css-extract-plugin
export default {"flex_box":"View_flex_box__N-Mlg"};